import isBrowser from "@secureo/common/utils/isBrowser"

const hasCSSGridSupport = () => !isBrowser() || window.CSS.supports("display", "grid")

export default hasCSSGridSupport
